import React from "react";
import { PageHead } from "@/components/kit";
import { ActionList, useActions } from "@/components/Actions";

export default function Actions() {
  const { items, counts } = useActions();
  return (
    <div data-testid="actions-page">
      <PageHead
        kicker="Everything open"
        title="What needs you"
        sub={
          items.length
            ? `${counts.now} need you now · ${counts.yours} are yours`
            : "Nothing is waiting on you."
        }
      />
      <ActionList items={items} />
    </div>
  );
}
